export const ship = {
  title: 'Warehouse-out(Transfer)',
}
